import { EnvironmentProviders, Provider } from '@angular/core';

import { ImageEditorTagsGateway } from '@efficiently/client-api-image-editor';
import { contentProviders } from '@efficiently/client-domain-content';
import { corporateProviders } from '@efficiently/client-domain-corporate';

import { CONTENT_PROVIDERS } from './pages/org-admin/client-portal/configurator/domain-content';
import { FOLDER_PROVIDERS } from './pages/org-admin/client-portal/configurator/domain-folders';
import { ImageEditorTagsGatewayService } from './shared/modules/image-editor-dialog/image-editor-tags-gateway.service';

export const APP_DOMAIN_PROVIDERS: (Provider | EnvironmentProviders)[] = [
	FOLDER_PROVIDERS, // configurator-local FolderStore (page-scoped)
	CONTENT_PROVIDERS, // configurator-local ContentUploadStore (page-scoped)
	...contentProviders, // app-wide content repos & ContentUploadService
	...corporateProviders, // app-wide org-connect repos & invite service
	{ provide: ImageEditorTagsGateway, useClass: ImageEditorTagsGatewayService }, // image editor → app tag store bridge
];
